import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import logo from '../assets/brand_Logo1.png';

const Footer = () => {
  return (
    <footer className="bg-[#F6F1EC] text-[#4b2b1b] shadow-[0_-4px_6px_rgba(0,0,0,0.1)] p-4">

      {/* MAIN SECTION */}
      <div className="container mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-10 items-center">

        {/* ---------- LEFT: LOGO ---------- */}
        <div className="flex flex-col items-center">
          <img
            src={logo}
            alt="Brand Logo"
            className="w-64 mb-4"
          />
        </div>

        {/* ---------- MIDDLE: CONTACT ---------- */}
        <div className="text-center">
          <h3 className="text-lg font-bold mb-4">Contact</h3>
          <p className="font-medium">
            E-mail:{" "}
            <a href="mailto:samartha.collections16@gmail.com" className="underline" onClick={(e) => e.stopPropagation()}>
              samartha.collections16@gmail.com
            </a>
          </p>

          <p className="font-medium mt-2">
            (M): +91 7249811801 , +91 8806649576
          </p>

          {/* SOCIAL ICONS */}
          <div className="flex justify-center gap-4 mt-5">
            <a href="https://instagram.com/samartha_ornaments19" target="_blank" rel="noreferrer">
              <FaInstagram size={24} />
            </a>

            <a
              href="https://chat.whatsapp.com/IAjtYYRZy4Z35gzNX4flsD"
              target="_blank"
              rel="noreferrer"
            >
              <FaWhatsapp size={24} />
            </a>
          </div>
        </div>

        {/* ---------- RIGHT: POLICY LINKS ---------- */}
        <div className="text-center">
          <h3 className="text-lg font-bold mb-4">Policies</h3>

          <ul className="space-y-3">
            <li>
              <Link to="/shipping-policy" className="hover:underline">
                Shipping Policy
              </Link>
            </li>

            <li>
              <Link to="/refund-policy" className="hover:underline">
                Return & Refund Policy
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* ---------- COPYRIGHT BAR ---------- */}
      <div className="border-t border-[#e6d9cd] py-4 text-center font-medium">
        © {new Date().getFullYear()}, All rights reserved @Samartha Ornaments
      </div>
    </footer>
  );
};

export default Footer;
